log = require 'loglevel'
Tween = require 'tween'
BaseManager = require 'BaseManager'
deviceManager = require 'deviceManager'
eventManager = require 'eventManager'
realityManager = require 'realityManager'
trackingManager = require 'trackingManager'

AnimationFrame = require 'animationFrame'
Stats = require 'stats.js'

gameModel = require 'gameModel'

###############################################

class CanvasManager extends BaseManager

  name: 'CanvasManager'
  views:[]
  overlays:[]
  historyStates: []
  transitionSpeed: 300
  parallaxBgOffeset: 150
  isTransitioning: false

  # -------------------------------------------

  constructor: ->
    super()

    window.onpopstate = (e) => @popHistory(e)

    eventManager.listenTo 'back', => @back()
    eventManager.listenTo 'force-back', => @forceBack()

    window.nc = @

  # -------------------------------------------

  setup: (gameBg, bottomBarView, parallax) ->

    @parallaxBgOffeset = parallax
    @bottomBarView = bottomBarView
    @gameBg = gameBg

  #----------------------------------------------

  renderCanvas: ->
    log.info @name, 'renderCanvas'

    @canvasContainerEle = document.getElementById('canvas-container')
    @canvasEle = document.getElementById('canvas')

    # stage options
    rendererOptions =
      view: @canvasEle
      transparent: true
      autoResize: true
      antialias: false
      resolution: __dpi
      clearBeforeRender: false

    w = gameModel.gameWidth
    h = gameModel.gameHeight

    # create renderer
    @renderer = new PIXI.autoDetectRenderer w, h, rendererOptions
    @renderer.backgroundColor = 0xFF66CC
    # @renderer.roundPixels = true
    window.__renderer = @renderer
    @disableScrolling()

    # add stage
    @outerStage = new PIXI.Container()
    @innerStage = new PIXI.Container()
    @outerStage.addChild @innerStage

    # show FPS stat
    if gameModel.fps
      hasStats = true
      stats = new Stats()
      stats.domElement.style.position = 'fixed'
      stats.domElement.style.left = '0px'
      stats.domElement.style.top = '0px'
      stats.domElement.id = 'stats-container'
      document.body.appendChild( stats.domElement )

    @addBackground()
    @addUiBars()


    animationFrame = new AnimationFrame(60)

    # render loop
    animate = =>
      stats.begin() if hasStats?
      @renderLoop()
      stats.end() if hasStats?
      animationFrame.request animate

    # begin animation
    animate()

  #----------------------------------------------

  renderLoop: (time) ->
    return if @freezeGame
    eventManager.trigger 'frame', time
    @renderer.render @outerStage

  # -------------------------------------------

  showCanvasEle: ->
    @canvasEle.style.display = 'block'

  # -------------------------------------------

  sizeToFit: ->

    return unless @canvasEle?

    # get viewport dimensions
    vp = deviceManager.getViewport()
    w = vp.w
    h = vp.h

    gW = gameModel.gameWidth
    gH = gameModel.gameHeight

    # prevent from stretching vertically
    # if h > gH and __isMobile
    #   h = gH

    # build ratios
    widthGrowthRatio = w/gW
    heightGrowthRatio = h/gH


    # determine the ratio that fits
    if heightGrowthRatio > widthGrowthRatio
      rendererW = gW
      rendererH = Math.round(h * gW / w)

    else
      rendererW = Math.round(w * gH / h)
      rendererH = gH

    @renderer.resize rendererW, rendererH

    @canvasEle.style.width = w + 'px'
    @canvasEle.style.height = h + 'px'
    @canvasContainerEle.style.width = w + 'px'
    @canvasContainerEle.style.height = h + 'px'



    # #set new gameDimensions
    ratio = w / rendererW
    gameModel.scaledRatio = ratio
    gameModel.rendererWidth = rendererW
    gameModel.rendererHeight = rendererH

    @centerBg()

    # center stage
    x = Math.round((rendererW-gW)/2)
    y = Math.round((rendererH-gH)/2)
    y = 0
    @innerStage.position.set(x,y)

    gameModel.stageX = x
    gameModel.stageY = y

    if @bottomBarView?
      @bottomBarView.resize rendererW, rendererH

    if @topBarView?
      @topBarView.resize rendererW, rendererH

    if @backgroundView?.resize?
      @backgroundView.resize rendererW, rendererH, @parallaxBgOffeset, @views.lastItem().name

    @rendererWidth = rendererW
    @gameWidth = gameModel.gameWidth
    @stageX = x

  # -------------------------------------------

  addBackground:  ->
    @gameBg.anchor.set gameModel.backgroundAnchorX, gameModel.backgroundAnchorY
    @outerStage.addChildAt @gameBg, 0
    @centerBg()

  # -------------------------------------------

  addUiBars: ->
    @outerStage.addChild @bottomBarView
    @outerStage.addChild @topBarView if @topBarView?

  # -------------------------------------------

  bringUiToFront: ->
    @bottomBarView.bringToFront()
    @topBarView.bringToFront() if @topBarView?

  # -------------------------------------------

  centerBg: ->

    if @gameBg?
      @scaleToFill(@gameBg,@parallaxBgOffeset)
      @gameBg.originalX = @gameBg.position.x

  # -------------------------------------------

  addBackgroundView: (@backgroundView, cb) ->
    @backgroundView.setup gameModel.rendererWidth, gameModel.rendererHeight, @parallaxBgOffeset, =>

      @outerStage.addChildAt @backgroundView, 1
      cb()

  # -------------------------------------------

  scaleToFill: (sprite, parallaxPadding)->

    rW = gameModel.rendererWidth + parallaxPadding
    rH = gameModel.rendererHeight
    bgW = sprite.texture.width
    bgH = sprite.texture.height

    if gameModel.backgroundAnchorX > 0
      rW = rW + (parallaxPadding/gameModel.backgroundAnchorX)

    ratioW = rW/bgW
    ratioH = rH/bgH

    rAspect = rW/rH
    bgAspect = bgW/bgH

    if rAspect > bgAspect
      ratio = ratioW
    else
      ratio = ratioH

    # center
    x = Math.floor(rW*gameModel.backgroundAnchorX) - ((rW - gameModel.rendererWidth - parallaxPadding)/2)
    y = Math.floor(rH*gameModel.backgroundAnchorY)

    sprite.scale.set ratio,ratio

    sprite.position.set x, y

  # -------------------------------------------

  pushView: (view) ->
    # get rid of the menu buttons

    # prevent mulitple views in the overlay stack
    if @isViewShowing view.name
      return

    @_pushView(view)

    if @views.length > 1 and not view.isHTML?
      @topBarView.showBackButton() if @topBarView?

    @bringUiToFront()

  # -------------------------------------------

  _pushView: (view) ->

    log.info @name, 'pushView', view.name

    # only push one view at a time
    return if @isTransitioning
    @isTransitioning = true

    # if we are pushing an html page above the canvas
    if view.isHTML? and view.isHTML
      realityManager.canShowRealityCheck(false)

    # is this the root view
    isRootView = @views.length < 1

    # fire event on view, if defined
    view.willShow() if view.willShow?

    # if this will not be the first view in the stack
    # then we will animate its movement
    unless isRootView

      # add a push state
      @pushHistory(view.name)

      # put view just out of screen to the right
      view.x = @rendererWidth

      # get current view
      currentView = @views.lastItem()

      # make view non-interactive
      currentView.interactiveChildren = false

      # make static snap shot of view
      # currentView.cacheAsBitmap = true

      # fire event on previous view, if defined
      currentView.willHide() if currentView.willHide?

      # for child in currentView.children
      #   child.reset() if child.tag is 'button'

    # put view on stage
    @innerStage.addChild view

    # add view to our stack
    @views.push view

    # don't animate if this the first view
    if isRootView

      view.didShow() if view.didShow?
      @isTransitioning = false
      return

    # calculate parallax x offset
    newX = @gameBg.position.x - @parallaxBgOffeset

    # animate background parallax

    Tween.to(@gameBg, @transitionSpeed/1000, {x:newX})

    # slide in new view
    options =
      x: 0

      onUpdate: =>
        if view.showingProgress?
          ratio = view.x / @rendererWidth
          domX = window.innerWidth * ratio
          view.showingProgress(domX)

      onComplete: =>
        view.didShow() if view.didShow?
        @isTransitioning = false

    Tween.to(view, @transitionSpeed/1000, options)

    # slide out old view
    options =
      x: -@stageX - @gameWidth
      onComplete: =>
        currentView.renderable = false
        currentView.didHide() if currentView.didHide?

    Tween.to(currentView, @transitionSpeed/1000, options)

  # -------------------------------------------

  popView: ->

    return false if @isTransitioning or @views.length < 1

    @isTransitioning = true

    isRootView = @views.length is 1

    view = @views.pop()

    view.willHide() if view.willHide?

    # if we are popping an html page
    if view.isHTML? and view.isHTML
      realityManager.canShowRealityCheck(true)

    nextView = @views.lastItem()

    if nextView?
      nextView.willShow() if nextView.willShow?
      nextView.interactiveChildren = true
      nextView.renderable = true
      # nextView.cacheAsBitmap = false

    if @views.length is 1
      @rootViewShown()

    if isRootView
      view.didHide() if view.didHide?
      view.removeSelf()
      @isTransitioning = false
      return true

    # animate background parallax
    Tween.to(@gameBg, @transitionSpeed/1000, {x:@gameBg.originalX})

    # slide in new view
    options =
      x: @rendererWidth
      onUpdate: (e) =>
        if view.showingProgress?
          ratio = view.x / @rendererWidth
          domX = window.innerWidth * ratio
          view.showingProgress(domX)
      onComplete: =>
        view.didHide() if view.didHide?
        view.removeSelf()

    Tween.to(view, @transitionSpeed/1000, options)

    # slide out old view
    options =
      x: 0
      onComplete: =>
        nextView.didShow() if nextView.didShow?
        @isTransitioning = false

    Tween.to(nextView, @transitionSpeed/1000, options)

    return true

  # -------------------------------------------

  popAllViews: ->

    for view in @views
      break unless @popView()

  # -------------------------------------------

  isViewShowing: (name) ->
    o = @views.lastItem()
    return false unless o?.name?
    name is o.name

  # -------------------------------------------

  pushOverlay: (overlayView) ->

    # prevent mulitple views in the overlay stack
    if @isOverlayShowing overlayView.name
      return

    @_pushOverlay(overlayView)
    @bringUiToFront()

  # -------------------------------------------

  _pushOverlay: (overlayView) ->

    eventManager.trigger 'showing-overlay'

    log.info @name, 'pushOverlay', overlayView.name

    currentView = @views.lastItem()

    if currentView?
      # currentView.renderable = false
      currentView.interactiveChildren = false

    @outerStage.addChild overlayView
    @overlays.push overlayView

  # -------------------------------------------

  popOverlay: (suppressEvents=false) ->

    return false if @overlays.length < 1

    isLastOverlay = @overlays.length is 1

    view = @views.lastItem()

    if isLastOverlay
      view.willShow() if view.willShow?

    overlayView = @overlays.pop()

    eventManager.trigger 'hiding-overlay' unless suppressEvents

    currentView = @views.lastItem()
    clearTimeout @overlayTimer
    currentView.interactiveChildren = true
    # currentView.cacheAsBitmap = false
    currentView.filters = null

    log.info @name, 'popOverlay', overlayView.name

    overlayView.hide =>
      @outerStage.removeChild overlayView

      if isLastOverlay
        view.didShow() if view.didShow?

    return true

  # -------------------------------------------

  popAllOverlays: (suppressEvents) ->
    for overlay in @overlays
      break unless @popOverlay(suppressEvents)

  # -------------------------------------------

  isOverlayShowing: (name) ->
    o = @overlays.lastItem()
    return false unless o?.name?
    name is o.name

  # -------------------------------------------

  pushInitHistory: (view) ->
    @historyStates.push view
    history.pushState(@historyStates, "sub-menu", null)

  # -------------------------------------------

  pushHistory: (view) ->
    @historyStates.push view
    history.replaceState(@historyStates, "sub-menu", null)

  # -------------------------------------------

  popHistory: (e) ->
    if @historyStates.length > 1
      state = @historyStates.pop()
      window.history.pushState(@historyStates, "sub-menu", null)
      @popView()
      return

    window.history.back()

  # -------------------------------------------

  back: ->
    @popHistory()

  # -------------------------------------------

  forceBack: ->
    @historyStates = []
    window.history.back()

  # -------------------------------------------

  rootViewShown: ->
    @topBarView.hideBackButton() if @topBarView?

  # -------------------------------------------

  spacebarHit: (evt) ->
    return if @isTransitioning

    trackingManager.trackEvent 'SpaceBar', 'button', 'space'
    evt.preventDefault()

    overlay = @overlays.lastItem()
    view = @views.lastItem()

    if overlay?.spacebarHit?
      overlay.spacebarHit(evt)

    else if view?.spacebarHit?
      view.spacebarHit(evt)

  #----------------------------------------------

  enableUserActions: ->
    document.onkeydown = (evt) =>
      evt = evt || window.event
      if evt.keyCode is 32
        @spacebarHit(evt)
        return false

  # -------------------------------------------

  disableUserActions: ->

    document.onkeydown = null

  # -------------------------------------------

  enableScrolling: ->
    @renderer.plugins.interaction.autoPreventDefault = false
    @canvasEle.style['touch-action'] = 'pan-y'

  # -------------------------------------------

  disableScrolling: ->
    @renderer.plugins.interaction.autoPreventDefault = true
    @canvasEle.style['touch-action'] = 'none'

  # -------------------------------------------

  uploadImagesToGPU: (names) ->
    for name in names
      @uploadImageToGPU name

  # -------------------------------------------

  uploadImageToGPU: (resourceName) ->
    t = new PIXI.Texture.fromImage resourceName
    # @renderer.bindTexture t

  # -------------------------------------------

module.exports = CanvasManager.getInstance()



// WEBPACK FOOTER //
// ./coffee/manager/canvas-manager.coffee